// extracted by mini-css-extract-plugin
module.exports = {"Labels":"EventsTable_Labels__2WWf-"};